<template>
  <section class="profile-wrapper">
    <div v-if="applied" class="container">
      <div class="row justify-content-center">
        <div class="col-6 col-xs-12 col-md-6 justify-content-center">
          <ApplySuccess application="true" />
        </div>
      </div>
    </div>
    <div v-else class="container">
      <div class="mobile-only top-bar">
        <nuxt-link to="/p-loan" class="btn btn-default">
          <i class="fas fa-chevron-left" />
        </nuxt-link>
      </div>
      <div class="row">
        <div class="col-12 profile-content form-content">
          <form
              id="lead-form"
              @submit.prevent="formSubmit"
              :class="{ loading: submitting }"
              action="#"
              :data-survey-code="formId"
          >
            <div class="profile-panel">
              <div class="row application-header">
                <div class="col-sm-6 col-xs-12 no-padding">
                  <img :src="logo" :alt="companyName" />
                </div>
                <div class="col-sm-6 col-xs-12 no-padding">
                  <h3>{{ companyName }}</h3>
                  <h4>{{ t("application.personal_form") }}</h4>
                </div>
              </div>
              <CommonFields
                  :companyId="companyId"
                  :companyName="companyName"
                  :from="from"
                  :productId="productId"
                  :vendorEmail="vendorEmail"
                  :vendorMobile="vendorMobile"
                  productType="loan"
                  :asCompany="true"
              />
              <StepShort
                  v-if="isShortForm"
                  :verifyMobile="survey.verifyMobile || false"
              />
              <section v-else>
                <Step1 ref="step1" v-show="currentStep === 1" />
                <Step2 ref="step2" v-show="currentStep === 2" />
                <Step3
                    ref="step3"
                    v-show="currentStep >= 3 && currentStep < maxStep - 1"
                    :step="currentStep - 2"
                />
                <Step4 ref="step4" v-show="currentStep === maxStep - 1" />
                <Step5
                    ref="step5"
                    v-show="currentStep === maxStep"
                    :checkTu="checkTu"
                    :hkid="hkid"
                    :companyName="companyName"
                    :verifyEmail="survey.verifyEmail || false"
                    :verifyMobile="survey.verifyMobile || false"
                />
              </section>
            </div>
            <div class="row botton-bar">
              <div class="col-12">
                <button
                    v-if="currentStep > 1"
                    @click="prevStep"
                    type="button"
                    class="btn btn-white btn-md btn-default"
                >
                  {{ t("common.prev_step") }}
                </button>
                <button
                    @click="nextStep"
                    type="button"
                    class="btn btn-secondary btn-md"
                >
                  <span>{{
                      currentStep >= maxStep
                          ? t("filter.done")
                          : t("common.next_step")
                    }}</span>
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import Step1 from "../p-loan/lead/components/Step1.vue";
import Step2 from "../p-loan/lead/components/Step2.vue";
import Step3 from "../p-loan/lead/components/Step3.vue";
import Step4 from "../p-loan/lead/components/Step4.vue";
import commonFunc from "../../assets/js/commonHelper";
import Step5 from "./components/Step4.vue";
import StepShort from "./components/StepShort.vue";
import CommonFields from "./components/CommonFields.vue";
import ApplySuccess from "~/components/form/ApplySuccess.vue";
export default {
  components: {
    ApplySuccess,
    Step1,
    Step2,
    Step3,
    Step4,
    Step5,
    StepShort,
    CommonFields
  },
  data: function () {
    return {
      logo: "",
      companyName: "",
      from: "web",
      companyId: "",
      productId: "",
      vendorEmail: "",
      vendorMobile: "",
      currentStep: 1,
      maxStep: 7,
      hkid: "",
      checkTu: false,
      formId: "",
      applied: false,
      submitting: false,
      incomeProveOptions: [],
      survey: {},
      isShortForm: false,
      applicationData: {},
      token: ""
    };
  },
  layout(context) {
    return "default";
  },
  head() {
    return {
      ...commonFunc.getSeoMeta(this.$store.state.layout.seo),
      bodyAttrs: {
        class:
            "no-header-footer-page profile-page lead-page form-page " +
            this.from +
            "-page",
      },
    };
  },
  async asyncData({ store, route, redirect }) {
    const slug = route.params.slug;
    const from = route.query.from || "web";
    const id = commonFunc.getIdFromSlug(slug);
    const params = {
      id: id,
    };
    await store.dispatch("search/fetchList", { type: "loan", params: params });
    await store.dispatch("form/fetchCompany");
    await store.dispatch("form/fetchAppliedVendors");
    const list = JSON.parse(JSON.stringify(store.state.search.list));
    const detail = list[0];
    if (detail === undefined ||
        (detail.applyButtonAction !== "ApplicationForm" &&
            detail.applyButtonAction !== "PLoanShortForm")
    ) {
      return redirect("/not_found");
    }
    await store.dispatch("option/fetchIncomeProofType");
    const incomeProveOptions = JSON.parse(JSON.stringify(store.state.option.incomeProofTypes)
    );
    const hkidParam = route.query.ref || "";
    let hkid = "";
    if (hkidParam) {
      hkid = Buffer.from(hkidParam, "base64").toString();
      await store.dispatch("form/fetchDetail", hkid);
    }
    await store.dispatch("form/fetchSurveyCode", detail.surveyId);
    const defaultFormId =
        detail.applyButtonAction === "PLoanShortForm" ? process.env.FORM_APPLICATION_SHORT_ID : "ploanApplicationForm";
    await store.dispatch("layout/fetchSeo", {
      path: route.path
    });
    const token = route.query.token;
    let applicationData = {};
    if (token) {
      await store.dispatch("search/fetchApplicationData", { token: token });
      applicationData = store.state.search.applicationData;
      console.log(applicationData);
    }
    return {
      incomeProveOptions: incomeProveOptions,
      companyName: detail.company.name,
      companyId: detail.company.id,
      productId: id,
      hkid: hkid,
      checkTu: detail.checkTu || false,
      formId: defaultFormId,
      survey: store.state.form.survey,
      from: from,
      isShortForm: detail.applyButtonAction === "PLoanShortForm",
      vendorEmail: detail.company.emailList ? detail.company.emailList.join(",") : "",
      vendorMobile: detail.company.mobileList ? detail.company.mobileList.join(",") : "",
      logo: commonFunc.getCompanyLogo(detail.company.logo),
      applicationData: applicationData,
      token: token
    };
  },
  async mounted() {
    window.vm = this;
    this.initialized = true;
    if (this.isShortForm) {
      this.maxStep = 1;
    }
    commonFunc.initForm();
    try {
      await this.$recaptcha.init()
    } catch (e) {
      console.error(e);
    }
  },
  beforeDestroy() {
    this.$recaptcha.destroy();
  },
  methods: {
    prevStep: function () {
      this.currentStep -= 1;
    },
    nextStep: async function (e) {
      if (!commonFunc.formValidate("lead-form")) {
        e.preventDefault();
        return false;
      }
      if (this.currentStep < this.maxStep) {
        if (this.currentStep === this.maxStep - 1 && !this.$refs.step4.beforeSubmit()) {
          e.preventDefault();
          return false;
        }
        if (this.currentStep >= 3 && this.currentStep < this.maxStep - 1 && !this.$refs.step3.beforeSubmit()) {
          e.preventDefault();
          return false;
        }
        if (this.currentStep === 1) {
          if (!await this.$refs.step1.beforeSubmit()) {
            e.preventDefault();
            return false;
          }
        }
        if (this.currentStep === 2) {
          this.$refs.step2.beforeSubmit();
        }
        this.currentStep += 1;
        commonFunc.scrollToTop();
        e.preventDefault();
        return false;
      }
      this.formSubmit(e);
    },
    formSubmit: function (e) {
      if (
        this.submitting ||
        this.currentStep < this.maxStep || !commonFunc.formValidate()
      ) {
        e.preventDefault();
        return false;
      }
      // if (this.currentStep === this.maxStep && !this.$refs.step5.beforeSubmit()) {
      //   e.preventDefault();
      //   return false;
      // }
      this.submitting = true;
      // const form = $("#lead-form");
      const uri = "/p-loan/recommend/application";

      const vm = this;
      const formId = "ploanApplicationForm";
      window.dataLayer.push({ event: "surveyFormSubmit", formType: this.type });
      commonFunc.surveyFormSubmit(
        "application-form",
        formId,
        function () {
          window.location.href = uri;
        },
        function (error) {
          commonFunc.toast(error, "danger");
          vm.submitting = false;
        }, this.$recaptcha, false, this.token
      );
      e.preventDefault();
      return false;
    },
  },
};
</script>